import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './SimpleLink.scss';
export const SimpleLink = (_param)=>{
    var { className , children , size ='medium' , isGreen  } = _param, props = _object_without_properties(_param, [
        "className",
        "children",
        "size",
        "isGreen"
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _extends({}, props, {
        className: c(className, s['link'], isGreen && s['green'], s[size])
    }), children);
};
SimpleLink.displayName = 'SimpleLink';
export default SimpleLink;
